import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  toastInfoRef: any;
  toastErrorRef: any;
  toastSuccessRef: any;
  constructor(private toastr: ToastrService) {
  }

//*********************************************************************************** */
  showSuccessWithTimeout(message: any, title: any) {
    this.toastSuccessRef = this.toastr.success(message, title, {
      disableTimeOut: true,
      tapToDismiss: false,
      positionClass: 'toast-bottom-left'
    })
  }
  hideSuccessToast() {

    if (typeof (this.toastSuccessRef) == 'object') {
      this.toastr.clear(this.toastSuccessRef.toastId)
    }
  }
  //*********************************************************************************** */
  showInfoWithTimeout(message: any, title: any) {
    this.toastInfoRef = this.toastr.info(message, title, {
      disableTimeOut: true,
      tapToDismiss: false,
      progressBar: false,
      progressAnimation:'increasing',
      positionClass: 'toast-bottom-left'
    })
  }
  hideInfoToast() {
    if (typeof (this.toastInfoRef) == 'object') {
      this.toastr.clear(this.toastInfoRef.toastId)
    }
  }
  /************************************************************************************* */
  showErrorWithTimeout(message: any, title: any) {
    this.toastErrorRef = this.toastr.error(message, title, {
      disableTimeOut: true,
      tapToDismiss: false,
      positionClass: 'toast-bottom-left'
    })
  }
  hideErrorToast() {
    if (typeof (this.toastErrorRef) == 'object') {
      this.toastr.clear(this.toastErrorRef.toastId)
    }
  }
  //*********************************************************************************** */
  /************************************************************************************* */
  showWarningWithTimeout(message: any, title: any) {
    this.toastErrorRef = this.toastr.warning(message, title, {
      disableTimeOut: true,
      tapToDismiss: false,
      positionClass: 'toast-bottom-left'
    })
  }
  hideWarningToast() {
    if (typeof (this.toastErrorRef) == 'object') {
      this.toastr.clear(this.toastErrorRef.toastId)
    }
  }
  //*********************************************************************************** */
}